import { render, staticRenderFns } from "./admin-dashboard.html?vue&type=template&id=4f38356c&"
import script from "./admin-dashboard.js?vue&type=script&lang=js&"
export * from "./admin-dashboard.js?vue&type=script&lang=js&"
import style0 from "./admin-dashboard.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports